var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-customer-preview-accept-success"},[_c('div',{staticClass:"_page-content"},[_c('h3',[_vm._v("Thanks!")]),_c('undo-form',{staticClass:"_undo-form",attrs:{"plushieId":_vm.plushieId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }